import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import { isNil } from 'lodash'

class WindOverlay extends React.Component {
  constructor(props) {
    super(props)
    this.position = this.props.position ? this.props.position : { lat: 47.282129, lng: -116.599781 }
    this.circleRef = new google.maps.Circle({
      center: new google.maps.LatLng(this.position),
      radius: 200
    })
    this.frameRequest = 0
    this.animateCanvas = this.animateCanvas.bind(this)
    this.insertMapOverlay = this.insertMapOverlay.bind(this)
    this.particleConfig = {
      velocity: 2,
      radius: 10,
      r: 255,
      g: 255,
      b: 255,
      maxParticleAge: 10000
    }
  }

  componentDidMount() {
    const { position } = this.props
    this.insertMapOverlay(this.circleRef.getBounds())
    this.circleRef.setCenter({ lat: position.lat, lng: position.lng })
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.frameRequest)
    this.mapOverlay.setMap(null)
    this.mapOverlay = null
    this.circleRef = null
  }

  insertMapOverlay(refBounds) {
    const canvas = document.createElement('canvas'),
      animateCanvas = this.animateCanvas,
      hideArrow = this.props.hideArrow,
      dir = this.props.direction
    class WindMapOverlay extends google.maps.OverlayView {
      constructor(bounds) {
        super()
        this.bounds_ = bounds
        this.div_ = null
      }
      onAdd() {
        const div = document.createElement('div'),
          arrow = document.createElement('img')
        arrow.src = '../../../../asset/wind-overlay-arrow.png'
        arrow.className = 'wind-overlay-arrow'
        // div.style.border = '1px solid red'
        div.style.position = 'absolute'
        if (hideArrow) {
          arrow.style.visibility = 'hidden'
        }
        canvas.className = 'wind-overlay'
        canvas.width = 500
        canvas.height = 1000
        div.appendChild(canvas)
        div.appendChild(arrow)
        div.style.transform = `rotate(${dir}deg)`
        this.div_ = div

        const panes = this.getPanes()
        panes.overlayLayer.appendChild(this.div_)
        window.panes = panes
      }
      draw() {
        if (this.bounds_) {
          const overlayProjection = this.getProjection(),
            sw = overlayProjection.fromLatLngToDivPixel(
              this.bounds_.getSouthWest()
            ),
            ne = overlayProjection.fromLatLngToDivPixel(
              this.bounds_.getNorthEast()
            )
          if (this.div_) {
            this.div_.style.left = sw.x + 'px'
            this.div_.style.top = ne.y + 'px'
            this.div_.style.width = ne.x - sw.x + 'px'
            this.div_.style.height = sw.y - ne.y + 'px'
          }
        }
      }
      onRemove() {
        if (this.div_) {
          this.div_.parentNode.removeChild(this.div_)
          this.div_ = null
        }
      }
    }
    const mapOverlay = new WindMapOverlay(refBounds)
    mapOverlay.setMap(this.props.mapReference)
    this.frameRequest = window.requestAnimationFrame((time) => { animateCanvas(canvas, [], time) })
    this.mapOverlay = mapOverlay

  }

  animateCanvas(canvas, particles = [], timeStamp) {
    const context = canvas.getContext('2d'),
      width = canvas.width,
      height = canvas.height,
      emitter = {
        position: { x: 0, y: canvas.height / 2 }
      },
      velocity = !isNaN(parseInt(this.props.speed)) ? this.props.speed / 10 : 0,
      particleConfig = this.particleConfig

    class Particle {
      constructor(x, y, velocityY, spawned) {
        this.radius = particleConfig.radius
        this.velocityY = velocityY
        this.position = { x, y }
        this.spawned = spawned
      }
      shouldRemove(time) {
        const dist = Math.sqrt(Math.pow(emitter.position.x - this.position.x, 2) +
          Math.pow(emitter.position.y - this.position.y, 2))
        return (isNaN(this.spawned) ||
          time - this.spawned >= particleConfig.maxParticleAge ||
          dist >= width)
      }
      move(distX, distY = null) {
        this.position.x += !isNil(distX) ? distX : velocity
        this.position.y += !isNil(distY) ? distY : this.velocityY
      }
    }

    const steps = Math.floor(width / velocity),
      maxVel = (height / (Math.max(1, velocity))) / steps,
      randVelocity = (Math.random() * maxVel) - (maxVel / 2)

    particles = particles.filter(particle => !particle.shouldRemove(timeStamp)).concat([
      new Particle(emitter.position.x, emitter.position.y, randVelocity, timeStamp),
      new Particle(emitter.position.x, emitter.position.y, randVelocity, timeStamp)
    ])

    context.clearRect(0, 0, canvas.width, canvas.height)

    particles.forEach(particle => {
      particle.move(this.particleConfig.x)
      const { x, y } = particle.position,
        { radius, spawned } = particle,
        ageAlpha = 1 - ((timeStamp - spawned) / this.particleConfig.maxParticleAge),
        dist = Math.sqrt(Math.pow(emitter.position.x - x, 2) +
          Math.pow(emitter.position.y - y, 2)),
        alpha = Math.min(ageAlpha, (1 - (dist / width))),
        { r, g, b } = this.particleConfig

      context.fillStyle = `rgba(${r},${g},${b},${alpha})`
      context.beginPath()
      context.arc(x, y, radius, 0, 2 * Math.PI)
      context.fill()
    })
    this.frameRequest = requestAnimationFrame((time) => { this.animateCanvas(canvas, particles, time) })
  }

  render() {
    if (this.mapOverlay && this.mapOverlay.div_) {
      this.position = this.props.position ? this.props.position : { lat: 47.282129, lng: -116.599781 }
      this.circleRef.setCenter(this.props.position)
      this.mapOverlay.bounds_ = this.circleRef.getBounds()
      this.mapOverlay.div_.style.transform = `rotate(${this.props.direction}deg)`
      this.mapOverlay.draw()
    }
    return null
  }
}

const mapStateToProps = state => ({
  mapReference: state.mapReference()
})

export default connect(mapStateToProps)(WindOverlay)